import './scss/index.scss';
import { dcFactory } from 'dc';
import HeritageSearchComponent from './js/heritage-search.component';

dcFactory.register(HeritageSearchComponent);
